import { GlobalAxios } from "../axios/axios-config";
import {
  IProfileListCategoriesPayload,
  IProfileListCategory,
} from "../models/profile-list-category";
import MainApi from "./mainApi.service";

const PROFILE_LIST_CATEGORIES_ROUTE =
  process.env.REACT_APP_IDENTIY + "/api/v1/ProfileListCategories/";

export const createProfileListCategories = (
  item: IProfileListCategoriesPayload
) => {
  return GlobalAxios.post(PROFILE_LIST_CATEGORIES_ROUTE, item);
};

export const updateProfileListCategories = ({
  id,
  item,
}: {
  id: string;
  item: IProfileListCategoriesPayload;
}) => {
  return GlobalAxios.put(PROFILE_LIST_CATEGORIES_ROUTE + id, item);
};

export const deleteProfileListCategory = (id: string) => {
  return GlobalAxios.delete(PROFILE_LIST_CATEGORIES_ROUTE + id);
};

export class ProfileListCategoriesService extends MainApi<IProfileListCategory> {
  constructor() {
    super(PROFILE_LIST_CATEGORIES_ROUTE);
  }

  deleteItemById = (id: string) => deleteProfileListCategory(id);
}
